import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

/**
 * Build facts for bug reports. REACT_APP_VERSION comes from package.json via
 * the .env files and REACT_APP_BUILD_SHA from the image build; parts that are
 * not set are left out.
 */
export const aboutText = (env = process.env) => {
  const version = env.REACT_APP_VERSION;
  const sha = env.REACT_APP_BUILD_SHA;
  const chainId = env.REACT_APP_CHAIN_ID;
  return [
    version ? `LiveBetter Hub ${version}` : 'LiveBetter Hub',
    sha ? `build ${sha.slice(0, 7)}` : null,
    chainId ? `chain ${chainId}` : null,
  ].filter(Boolean).join(' · ');
};

export const AboutLine = () => {
  const text = aboutText();
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = async () => {
    const report = `${text}\nBrowser: ${navigator.userAgent}`;
    try {
      await navigator.clipboard.writeText(report);
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error('Copying is blocked in this browser. Select the text instead.');
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-[12px] text-lb-muted-soft">
      <span className="font-mono select-all" data-testid="about-text">{text}</span>
      <button
        type="button"
        onClick={copy}
        className="p-0 border-0 bg-transparent text-[12px] font-semibold text-lb-green-primary hover:underline cursor-pointer rounded outline-none focus-ring"
      >
        {copied ? 'Copied' : 'Copy for a bug report'}
      </button>
    </div>
  );
};
